import React, { useState, useEffect } from "react";

import { TableRow, TableCell } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  ModalDefaultError,
  ModalDeleteConfirm,
  TableAction,
  TableCellDefault,
  TableWrapper,
} from "App/Component/ui";

import { useDatatables } from "App/hooks";
import {
  getAllJenisHarga,
  ModalForm,
  headCells,
  deleteJenisHargaById,
  RESET_STATE_JENIS_HARGA,
} from "./helpers";

export default function Bank() {
  const [showModal, setShowModal] = useState(false);
  const [showModalDefaultError, setShowModalDefaultError] = useState(false);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const [rows, setRows] = useState([]);
  const [formData, setFormData] = useState(RESET_STATE_JENIS_HARGA);
  const [run, setRun] = useState(false);

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  useEffect(() => {
    (async () => {
      const res = await getAllJenisHarga();
      if (res) {
        setRows(res);
      } else {
        setShowModalDefaultError(true);
      }
    })();
  }, [run]);

  function clickUpdate(row) {
    setFormData({
      id: row?.id,
      name: row?.name,
      remark: row?.remark,
      status: row?.status,
    });

    setShowModal(true);
  }

  function clickDelete(row) {
    setFormData({
      ...formData,
      id: row?.id,
    });
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  function clickAdd() {
    setFormData(RESET_STATE_JENIS_HARGA);
    setShowModal(!showModal);
  }

  return (
    <>
      {showModal && (
        <ModalForm
          run={() => setRun(!run)}
          setShowModal={() => setShowModal(false)}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      {showModalDefaultError && (
        <ModalDefaultError
          setShowModalDefaultError={() => setShowModalDefaultError(true)}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() =>
            deleteJenisHargaById(
              formData.id,
              () => setRun(!run),
              setShowModalDeleteConfirm,
              setFormData
            )
          }
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}
      <TableWrapper
        title='Daftar Jenis Harga'
        setQ={setQ}
        clickAddButton={() => clickAdd()}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={`jenis-harga-${index}`}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  {index + 1}
                </TableCell>

                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  <TableAction
                    clickDelete={() => clickDelete(row)}
                    clickUpdate={() => clickUpdate(row)}
                  />
                </TableCell>

                <TableCell align='left'>{row?.name}</TableCell>
                <TableCell align='left'>{row?.remark}</TableCell>
                <TableCellDefault row={row} />
              </TableRow>
            );
          })}
      </TableWrapper>
    </>
  );
}
